<template>
  <div class="text-primary-200">{{ description }}</div>
</template>
<script>
import { defineComponent, inject, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  setup() {
    const article = inject('article', null);
    const description = computed(() => article?.description);
    return { description };
  },
});
</script>
